import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import RentalPlan from '../helpers/rental_plan'
import SalePlan from '../helpers/sale_plan'
import { useSession } from '../misc/session_context'
import { Alert } from 'lensrentals-components'
import styles from '../../assets/stylesheets/pages/cart/layout.module.scss'
import Items from './items'
import Lenscap from './lenscap'
import Shipping from './shipping'
import Schedule from './schedule'

const Cart = props => {
  const [showLenscapModal, setShowLenscapModal] = useState(false)

  useEffect(() => {
    window.pipetteEvents?.cartViewed(cartPlan.pipetteCartObject)
  })

  const toggleLenscapModal = event => {
    event && event.preventDefault() // if there is an event, make sure we don't accidentally submit the form
    setShowLenscapModal(!showLenscapModal)
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

  const [sessionData] = useSession()

  const {
    cartPlan,
    updateCartPlan,
    updating,
    dateCorrectionMessage
  } = props

  const {
    currentUser
  } = sessionData

  return (
    <form
      id='shopping_cart'
      className={cx(
        styles['shopping-cart'],
        'shopping-cart',
        updating ? 'updating' : 'updated'
      )}
      acceptCharset='UTF-8'
      action='/checkout'
      method='post'
    >
      <input name='utf8' type='hidden' value='✓' />
      <input type='hidden' name='authenticity_token' value={csrfToken} />
      <input type='hidden' name='checkout_type' value={cartPlan.type} />

      <main className={styles['shopping-cart__cart']}>
        <Items
          cartPlan={cartPlan}
          updateCartPlan={updateCartPlan}
          toggleLenscapModal={toggleLenscapModal}
        />
        {currentUser && currentUser.hdExpiredRecently &&
          <Alert
            className={cx('lrhd-expired', styles['shopping-cart__lrhd-expired'])}
            show={true}
            onClose={() => {}} // TODO - this needs to not be required in component library
            dismissible={false}
            color='default'
          >
            Your Lensrentals&trade; HD membership has expired.
          </Alert>}
        {cartPlan.type === 'rental' &&
          <Lenscap
            cartPlan={cartPlan}
            updateCartPlan={updateCartPlan}
            showLenscapModal={showLenscapModal}
            toggleLenscapModal={toggleLenscapModal}
          />}
      </main>
      <aside className={styles['shopping-cart__info']}>
        <Schedule
          className={styles['shopping-cart__info-block']}
          updateCartPlan={updateCartPlan}
          cartPlan={cartPlan}
          dateCorrectionMessage={dateCorrectionMessage}
        />
        <Shipping
          className={styles['shopping-cart__info-block']}
          cartPlan={cartPlan}
        />
      </aside>
    </form>
  )
}

Cart.propTypes = {
  cartPlan: PropTypes.oneOfType([
    PropTypes.instanceOf(RentalPlan),
    PropTypes.instanceOf(SalePlan)
  ]).isRequired,
  updateCartPlan: PropTypes.func.isRequired,
  updating: PropTypes.bool.isRequired,
  dateCorrectionMessage: PropTypes.string
}

export default Cart
